import PageTitle from '../components/PageTitle';
import { ButtonV2 } from '@cimplico/components';
import { useNavigate } from 'react-router-dom';
import NewCalculationForm from '../features/new-calculation/NewCalculationForm';

function NewCalculationPage(): JSX.Element {
    const navigate = useNavigate();

    function cancel(): void {
        navigate('..');
    }

    return (
        <div className="pb-4">
            <div className="pb-4 border-b flex justify-between">
                <PageTitle title="New Calculation" />
                <ButtonV2 type="secondary" label="Cancel" size="sm" onClick={cancel} />
            </div>
            <div className="mx-auto w-full flex justify-center mt-8">
                <NewCalculationForm />
            </div>
        </div>
    );
}

export default NewCalculationPage;
